/**
 * Supported UI languages. Adding a new locale = new entry here + a new JSON
 * file in `src/i18n/`. No component changes required — the header selector
 * and login page pull from this list.
 */
export const SUPPORTED_LANGUAGES = [
  { code: "de", label: "Deutsch", flag: "de" },
  { code: "en", label: "English", flag: "gb" },
];

export function findLanguage(code) {
  return (
    SUPPORTED_LANGUAGES.find((l) => l.code === code) || SUPPORTED_LANGUAGES[0]
  );
}
